import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

import { subscriptionProductsCrudStateConfig } from "../consts";

export const {
  fetchAllActionFactory: fetchAllSubscriptionProductsActionFactory
} = makeCrudStateActionFactories(subscriptionProductsCrudStateConfig);
